import React, { Component } from 'react';
import axios from 'axios';
import {
	Row,
	Col,
	Form,
	FormInput,
	FormGroup,
	FormCheckbox,
	Button,
	FormSelect,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
} from 'shards-react';

export default class FormDeatils extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			firstName: '',
			lastName: '',
			studyNumber: '',
			phone: '',
			phoneOperator: 'IAM',
			city: '',
			school: '',
			cardBack: null,
			cardFront: null,
			studentCardPhotos: [],
			message: '',
		};
	}

	handleSubmit = (event) => {
		event.preventDefault();
		this.setState({ loading: true });
		const {
			firstName,
			lastName,
			studyNumber,
			phone,
			phoneOperator,
			city,
			school,
			cardFront,
			cardBack,
		} = this.state;
		let studentCardPhotos = [...this.state.studentCardPhotos];
		studentCardPhotos.push(cardFront, cardBack);

		const formData = new FormData();
		formData.append('firstName', firstName);
		formData.append('lastName', lastName);
		formData.append('studyNumber', studyNumber);
		formData.append('phone', phone);
		formData.append('phoneOperator', phoneOperator);
		formData.append('city', city);
		formData.append('school', school);
		formData.append('studentCardPhotos', cardBack);
		formData.append('studentCardPhotos', cardFront);

		axios
			.post(`${process.env.REACT_APP_API_URL}/addstudent`, formData, {
				headers: {
					'content-type':
						'multipart/form-data; boundary=---011000010111000001101001',
				},
			})
			.then((response) => {
				this.setState({ loading: false });
				if (response.status === 200) {
					window.location = '/successful-request';
				}
			})
			.catch((error) => {
				this.setState({ loading: false });
				if (error.response.status === 400 || error.response.status === 409) {
					this.setState({
						message: error.response.data.message,
					});
				} else {
					this.setState({
						message: `Une erreur est survenue.Veuillez réessayer plus tard.`,
					});
				}
			});
	};

	handleSelectedFile = (event) => {
		const { name, files } = event.target;

		this.setState({
			[name]: files[0],
		});
	};

	handleChange = (event) => {
		const { name, value } = event.target;
		this.setState({ [name]: value });
	};
	render() {
		const {
			loading,
			firstName,
			lastName,
			studyNumber,
			cardBack,
			cardFront,
			phone,
			city,
			school,
			message,
		} = this.state;
		return (
			<Form id="form" onSubmit={this.handleSubmit}>
				<Row form>
					<Col md="6" className="form-group">
						<FormInput
							id="firstName"
							name="firstName"
							type="text"
							value={firstName}
							placeholder="Prénom"
							onChange={this.handleChange}
							required
						/>
					</Col>
					<Col md="6">
						<FormInput
							id="lastName"
							name="lastName"
							type="text"
							value={lastName}
							placeholder="Nom"
							onChange={this.handleChange}
							required
						/>
					</Col>
				</Row>
				<FormGroup>
					<FormInput
						id="studyNumber"
						name="studyNumber"
						type="number"
						value={studyNumber}
						placeholder="Code apogée"
						onChange={this.handleChange}
						required
					/>
				</FormGroup>
				<FormGroup>
					<InputGroup className="mb-3">
						<InputGroupAddon type="prepend">
							<InputGroupText>
								<i className="material-icons">local_phone</i>
							</InputGroupText>
						</InputGroupAddon>
						<FormInput
							id="phone"
							name="phone"
							type="number"
							value={phone}
							min="0"
							placeholder="Numéro de téléphone"
							onChange={this.handleChange}
							required
						/>
					</InputGroup>
				</FormGroup>
				<FormGroup>
					<FormSelect
						id="phoneOperator"
						name="phoneOperator"
						onChange={this.handleChange}
					>
						<option value="IAM">Maroc telecom</option>
						<option value="INWI">Inwi</option>
						<option value="ORANGE">Orange</option>
					</FormSelect>
				</FormGroup>
				<FormGroup>
					<InputGroup className="mb-3">
						<InputGroupAddon type="prepend">
							<InputGroupText>
								<i className="material-icons">location_city</i>
							</InputGroupText>
						</InputGroupAddon>
						<FormInput
							id="city"
							name="city"
							type="text"
							value={city}
							placeholder="Ville"
							onChange={this.handleChange}
							required
						/>
					</InputGroup>
				</FormGroup>
				<FormGroup>
					<InputGroup className="mb-3">
						<InputGroupAddon type="prepend">
							<InputGroupText>
								<i className="material-icons">school</i>
							</InputGroupText>
						</InputGroupAddon>
						<FormInput
							id="school"
							name="school"
							type="text"
							value={school}
							placeholder="Établissement"
							onChange={this.handleChange}
							required
						/>
					</InputGroup>
				</FormGroup>
				<Row form>
					<Col md="6" className="form-group">
						<div className="custom-file mb-3">
							<input
								type="file"
								className="custom-file-input"
								id="cardFront"
								name="cardFront"
								accept="image/*"
								required
								onChange={this.handleSelectedFile}
							/>
							<label className="custom-file-label" htmlFor="cardFront">
								{!cardFront ? "Carte d'étudiant avant" : cardFront.name}
							</label>
						</div>
					</Col>
					<Col md="6" className="form-group">
						<div className="custom-file mb-3">
							<input
								type="file"
								className="custom-file-input"
								id="cardBack"
								name="cardBack"
								accept="image/*"
								required
								onChange={this.handleSelectedFile}
							/>
							<label className="custom-file-label" htmlFor="cardBack">
								{!cardBack ? "Carte d'étudiant derrière" : cardBack.name}
							</label>
						</div>
					</Col>

					<Col md="12" className="form-group">
						<FormCheckbox required checked>
							{/* eslint-disable-next-line */}Je suis d'accord avec vos{' '}
							<a href="/termes-conditions">Termes et Conditions</a>.
						</FormCheckbox>
					</Col>
				</Row>
				<Row className="justify-content-center">
					<p>{message}</p>
				</Row>
				<Row className="justify-content-center">
					<Button type="submit" outline theme="primary" disabled={loading}>
						{loading && <i className="fa fa-refresh fa-spin"></i>}
						{loading && "Attendez s'il vous plaît"}
						Envoyer
					</Button>
				</Row>
			</Form>
		);
	}
}
